import React from "react";
import Form from "./Form";
import "./StartQuoting.css";

import quoteImage from '../../../assets/images/quote.gif';

const StartQuoting = () => {
  return (
    <div className="bg-white ">
      <div className="flex flex-col md:flex-row ml-5 mr-5 mt-10 mb-10">
          <Form />
        <div className="flex justify-center mt-10">
          <img className="quote-img" alt="certifications" src={quoteImage} />
        </div>
      </div>
      
    </div>
  );
};

export default StartQuoting;
